// extracted by mini-css-extract-plugin
export var container = "social-media-buttons-module--container--dEjz2";
export var link = "social-media-buttons-module--link--5DJI5";